import React from "react";
import { Loader } from "semantic-ui-react";
import { ErrorSegment } from "../../common/components/ErrorSegment";
import { PaginationButtons } from "../../common/components/PaginationButtons";
import { AreaTable } from "./AreaTable";

export const AreaActiveList = ({ areaData }) => {
  if (areaData.isPending) return <Loader active />;
  if (areaData.error) return <ErrorSegment message={areaData.error.message} />;
  if (areaData.data) {
    return (
      <>
        <AreaTable areas={areaData.data.results} reload={areaData.refetch} />
        <PaginationButtons
          previous={areaData.data?.previous}
          next={areaData.data?.next}
          onPrevious={areaData.handlePrevious}
          onNext={areaData.handleNext}
        />
      </>
    );
  }

  return null;
};
